import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "messageCount",
	standalone: true,
})
export class MessageCountPipe implements PipeTransform {
	static readonly MESSAGE_COUNT_THRESHOLD: number = 10;
	transform(count: number): string | null {
		if (count === null) return null;
		return !isNaN(count) ? (count < MessageCountPipe.MESSAGE_COUNT_THRESHOLD ? String(count) : "9+") : null;
	}
}
